import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Documentation } from '../Documentation/Documentation';
import { DocumentationV3 } from '../DocumentationV3/DocumentationV3';
import React from 'react';
export const DocumentationHandler = () => {
  const { service } = useParams();
  const isSuperconnector = service === 'superconnector';

  if (isSuperconnector) {
    return <DocumentationV3 />;
  }

  return <Documentation />;
};
